var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinguim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 127,
    viewBox: "0 0 77 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0638 30.5251C10.0689 33.4098 4.12146 34.183 0.659668 33.6061C12.3623 24.8185 9.8493 2.32567 28.4952 0.237695C40.8369 -1.14382 49.2973 4.32337 56.5894 13.8723C77.9679 41.8755 66.7278 91.1628 76.2311 126.913H30.3888C23.6455 116.368 19.8309 103 21.8225 84.0432C16.769 98.4589 17.9843 112.215 23.8376 126.913C-32.198 76.1701 77.7561 1.68594 23.6808 10.654C16.5259 11.8393 19.3173 16.0388 24.8334 17.9776C30.8867 20.1009 24.9393 27.3107 22.7399 30.5173C21.007 28.6098 18.2548 27.503 14.0638 30.5251Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinguim);
export default __webpack_public_path__ + "static/media/pinguim.e1961839589162b2cde07a5522eb7780.svg";
export { ForwardRef as ReactComponent };